import { FULL_REVIEW_LIST } from '../../constants/ActionTypes';

const initialState = {
  error: null,
  loaded: false,
  loading: false,
  result: {},
};

/**
 * Full Review List Reducer
 * @param {*} state
 * @param {*} action
 */
export default function fullReviewList(state = initialState, action = {}) {
  switch (action.type) {
    case `${FULL_REVIEW_LIST}_PENDING`:
      return {
        ...state,
        error: null, // state.error = null
        loaded: false, // state.loaded = false
        loading: true, // state.loading = true
      };
    case `${FULL_REVIEW_LIST}_SUCCESS`:
      return {
        ...state,
        error: null,
        result: action?.result,
        loaded: true,
        loading: false,
      };
    case `${FULL_REVIEW_LIST}_FAIL`:
      return {
        ...state,
        error: action.error,
        loaded: false,
        loading: false,
      };
    default:
      return state;
  }
}
